import { CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { BRAND_NAME } from '../../../../shared/env';
import { useShareCode } from '../../../../shared/hooks/caseHook';
import { BlueRoundedButtonWithIcon } from '../../common/components/BlueRoundedButton';
import { CheckboxWithText } from '../../common/components/CheckboxWithText';
import { Spacer } from '../../common/components/Spacer';
import { TermText } from '../../common/components/styledComponents';
import { whiteCircularProgressStyle } from '../../common/styles';

import { SelectedImageTable } from './SelectedImageTable';
import { ShareCodeModal } from './ShareCodeModal';

interface ShareToDoctorTabProps {
  cases: Case[];
}
export const ShareToDoctorTab = (props: ShareToDoctorTabProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages',
  });
  const { cases } = props;
  const [checkTerm, setCheckTerm] = useState(false);
  const isShareAvailable = cases.length && checkTerm;

  const [pincode, setPincode] = useState('');
  const { isPending, mutate: shareCode } = useShareCode({
    onSuccess: ({ code }) => {
      setPincode(code ?? '');
    },
  });
  const onClickShareButton = () => {
    shareCode({ caseId: cases.map(c => c.caseId) });
  };

  return (
    <>
      <SelectedImageTable data={cases} />
      <Spacer height={17} />
      <TermText>{t('share.terms.0', { brandName: BRAND_NAME })}</TermText>
      <Spacer height={27} />
      <CheckboxWithText
        text={<TermText>{t('share.terms.1')}</TermText>}
        value={checkTerm}
        onChange={value => setCheckTerm(value)}
      />
      <BlueRoundedButtonWithIcon
        maxWidth="239px"
        marginTop="61px"
        onClick={onClickShareButton}
        disabled={!isShareAvailable}>
        {isPending ? (
          <CircularProgress size={24} style={whiteCircularProgressStyle} />
        ) : (
          t('share.button')
        )}
      </BlueRoundedButtonWithIcon>
      <ShareCodeModal
        open={!!pincode.length}
        onClose={() => setPincode('')}
        code={pincode}
      />
    </>
  );
};
